<template>
  <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 500px;
    ">
    <van-loading></van-loading>
  </div>
</template>

<script>
export default {
  name: "public",

  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.forbidBack, false);
      this.forbidBack()
    }
  },

  // 中转页 跳转
  created() {
    const redirect = this.$route.query.redirect;
    this.$router.replace(redirect);
  },

  destroyed() {
    window.removeEventListener('popstate', this.forbidBack, false);
  },

  methods: {
    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    }
  }
};
</script>